export const languageConstants = {
  LABELS_REQUEST: "LABELS_REQUEST",
  LABELS_SUCCESS: "LABELS_SUCCESS",
  LABELS_FAILURE: "LABELS_FAILURE",
};
